/** Kaynak çözümleme durumu (pazarlama çalışma merkezi 2. tur anlam sözleşmesi § 5) */
export const SOURCE_STATES = ['resolved', 'inactive', 'unknown', 'not_found', 'deleted'];
/** Ad taşımayan durumların görünen metni (resolved/inactive: sözlükteki ad) */
export const SOURCE_STATE_LABELS = {
    unknown: 'Kaynak bilinmiyor',
    not_found: 'Kaynak bilgisi bulunamadı',
    deleted: 'Silinmiş kaynak',
};
/** Güvenilir silme kaydı (denetim kaydında kaynağın silinme olayı) olan anahtarın görünen adı */
export const DELETED_SOURCE_LABEL = SOURCE_STATE_LABELS.deleted;
/**
 * Kaynak anahtarı → durum + görünen ad. `lookups`: birleşik sözlük (`mergeLookups`; tenant adı sistem etiketini ezer).
 * `deletedKeys`: denetim kaydında silinme olayı bulunan anahtarlar (yalnız bu kanıtla `deleted`; kanıtsız eksik anahtar
 * `not_found`). Bilinmeyen kaynak hiçbir sağlayıcıya (Google/Meta/organik) eşlenmez. `key === null` → `unknown`.
 */
export function resolveSource(lookups, key, deletedKeys = new Set()) {
    if (key === null)
        return { state: 'unknown', label: SOURCE_STATE_LABELS.unknown, active: null };
    const l = lookups.find((x) => x.kind === 'source' && x.key === key);
    if (l !== undefined)
        return { state: l.isActive ? 'resolved' : 'inactive', label: l.label, active: l.isActive };
    return deletedKeys.has(key)
        ? { state: 'deleted', label: SOURCE_STATE_LABELS.deleted, active: null }
        : { state: 'not_found', label: SOURCE_STATE_LABELS.not_found, active: null };
}
//# sourceMappingURL=source-state.js.map